import * as Types from '../../lib/types';

export const TestimonialBlockData: Types.TestimonialBlock = {
  _type: 'testimonialBlock',
  _key: 'testimonialBlock_1',
  isDarkMode: true,
  backgroundMedia: {
    desktop: {
      _type: 'video',
      url: 'https://assets.thelightphone.com/videos/clouds.v2.mp4',
      alt: 'A video of clouds',
      posterImage: {
        _type: 'image',
        url: 'https://assets.thelightphone.com/images/cloudsPosterImage.png',
        alt: 'A photo of clouds'
      }
    }
  },
  testimonials: [
    {
      _type: 'testimonial',
      quote:
        'I love this phone. It will make you a happier, more present person.'
    },
    {
      _type: 'testimonial',
      quote: 'The Light Phone has probably given me back thousands of hours.'
    },
    {
      _type: 'testimonial',
      quote:
        'It’s like the fog in my head has finally been cleared out and I’m seeing and enjoying the world anew.'
    },
    {
      _type: 'testimonial',
      quote:
        'They said, ‘Because you’re never on it, you’re more fun.’ I can only imagine how many ‘fun Dad things’ I would have missed if it wasn’t for this thing.'
    },
    {
      _type: 'testimonial',
      quote:
        'Everyone in my work and home lives have commented on noticing an appreciable change in mood and productivity.'
    },
    {
      _type: 'testimonial',
      quote:
        'The ‘what ifs’ can be pretty overwhelming when considering the move, but honestly, l’ve not missed anything.'
    },
    {
      _type: 'testimonial',
      quote: 'It’s really refreshing to not be sold something all of the time.'
    },
    {
      _type: 'testimonial',
      quote: 'It’s more than a simple phone, it’s a lifestyle change.'
    }
  ]
};
